import React from 'react'

import { Button } from '../components/ui/button'
import { getTranslate } from '../utilities/i18n'
import SignUpHeader from './SignUpHeader'

type Props = { onClick: () => void }

const ErrorComponent: React.FC<Props> = ({ onClick }) => {
  const { t } = getTranslate()
  return (
    <div className="container flex h-screen flex-col">
      <SignUpHeader />
      <div className="flex flex-grow flex-col items-center justify-center pb-[25%]">
        <h2>{t('component.errorPage.heading')}</h2>
        <p className="mb-12">{t('component.errorPage.subheading')}</p>
        <p className="font-bold">{t('component.errorPage.suggestions.title')}</p>
        <ul className="mb-12 flex list-disc flex-col items-center text-secondary">
          <li>{t('component.errorPage.suggestions.1')}</li>
          <li>
            {t('component.errorPage.suggestions.2', {
              phoneNumber: t('general.support.phone'),
              email: t('support.contact.email.mailto'),
            })}
          </li>
        </ul>
        {onClick && (
          <Button onClick={onClick} variant="light">
            {t('component.button.logout')}
          </Button>
        )}
      </div>
    </div>
  )
}

export default ErrorComponent
